"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const utils_1 = require("@loadsure/utils");
class Fees {
    constructor(feeCalcs) {
        this.feeCalcs = feeCalcs;
        this.calculate = (currency, currencyConverter, value) => {
            const feeCalcs = this.feeCalcs.map((fee) => {
                var _a;
                return ({
                    partnerId: (_a = fee.partnerId) !== null && _a !== void 0 ? _a : "",
                    type: fee.type,
                    currency,
                    value: fee.calculate(currency, value, currencyConverter),
                    description: fee.description
                });
            });
            const feeTotal = feeCalcs
                .map((fee) => fee.value)
                .reduce((currentTotal, feeValue) => currentTotal + feeValue, 0);
            return {
                total: feeTotal,
                breakdown: feeCalcs
            };
        };
    }
    static fromObj(fees) {
        const feesArray = Array.isArray(fees) ? fees : [fees];
        return new Fees(feesArray.map(types_1.feeComponentFromObj).filter(utils_1.isObjectDefined));
    }
    static empty() {
        return new Fees([]);
    }
}
exports.default = Fees;
//# sourceMappingURL=fees.class.js.map